import { doc } from "firebase/firestore";
import { useFirestore, useFirestoreDocData } from "reactfire";

export const useFirestoreQueryDoc = (collection, uid) => {
  const ref = doc(useFirestore(), collection, uid)
  const { status, data } = useFirestoreDocData(ref);
  return { status, data };
};
